// @flow
import * as React from 'react';

type Props = {
    thumbnail: React.Node,
};

const ThumbnailCardThumbnail = ({ thumbnail }: Props) => (
    <div className="thumbnail-card-thumbnail-container">
        <div className="thumbnail-card-thumbnail-viewport">{thumbnail}</div>
    </div>
);

export default ThumbnailCardThumbnail;
